import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../services/api";

export default function CarpenterLabours() {
  const navigate = useNavigate();
  const [data, setData]           = useState([]); // [{carpenter, labours:[]}]
  const [loading, setLoading]     = useState(true);
  const [search, setSearch]       = useState("");
  const [expanded, setExpanded]   = useState({});  // { carpenterId: true/false }
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const navItems = [
    { label:"Dashboard",          emoji:"🏠", path:"/admin/dashboard" },
    { label:"Users",              emoji:"👥", path:"/admin/users" },
    { label:"Carpenter & Labour", emoji:"🔗", path:"/admin/carpenter-labours", active:true },
    { label:"Trash",              emoji:"🗑️", path:"/admin/trash" },
  ];

  const fetchData = async () => {
    setLoading(true);
    try {
      const res = await api.get("/admin/carpenter-labours");
      setData(res.data.data || []);
      // expand all by default
      const init = {};
      (res.data.data || []).forEach(c => { init[c.carpenter._id] = true; });
      setExpanded(init);
    } catch (e) { console.error(e); }
    finally { setLoading(false); }
  };

  useEffect(() => { fetchData(); }, []);

  const toggle = (id) => setExpanded(prev => ({ ...prev, [id]: !prev[id] }));

  const filtered = data.filter(c =>
    c.carpenter.name.toLowerCase().includes(search.toLowerCase()) ||
    c.carpenter.email.toLowerCase().includes(search.toLowerCase()) ||
    c.labours.some(l => l.name.toLowerCase().includes(search.toLowerCase()))
  );

  const totalLabours = data.reduce((s, c) => s + c.labours.length, 0);

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');
        @keyframes fadeUp { from{opacity:0;transform:translateY(14px)} to{opacity:1;transform:translateY(0)} }
        @keyframes spin   { to{transform:rotate(360deg)} }
        @keyframes slideDown { from{opacity:0;transform:translateY(-8px)} to{opacity:1;transform:translateY(0)} }
        *,*::before,*::after { box-sizing:border-box; margin:0; padding:0; }
        body { font-family:'Plus Jakarta Sans',sans-serif; background:#FAF7F4; }
        .sidebar { width:220px; flex-shrink:0; background:#fff; border-right:1.5px solid #E7E5E4; padding:24px 14px; display:flex; flex-direction:column; gap:6px; position:sticky; top:0; height:100vh; overflow-y:auto; }
        .topbar { display:none; }
        .hamburger { display:none; align-items:center; justify-content:center; width:40px; height:40px; border-radius:10px; border:1.5px solid #E7E5E4; background:#fff; cursor:pointer; flex-shrink:0; }
        .sidebar-overlay { display:none; position:fixed; inset:0; background:rgba(0,0,0,.4); z-index:40; }
        .nav-btn { display:flex; align-items:center; gap:9px; width:100%; padding:10px 12px; border-radius:10px; border:none; background:none; font-family:'Plus Jakarta Sans',sans-serif; font-size:14px; font-weight:600; color:#78716C; cursor:pointer; transition:background .15s,color .15s; text-align:left; }
        .nav-btn:hover,.nav-btn.active { background:#FEF3C7; color:#D97706; }
        .nav-btn.danger:hover { background:#FEF2F2; color:#DC2626; }
        .search-input { width:100%; padding:11px 16px 11px 42px; background:#fff; border:1.5px solid #E7E5E4; border-radius:12px; font-family:'Plus Jakarta Sans',sans-serif; font-size:14px; color:#1C1917; outline:none; transition:border-color .2s; }
        .search-input:focus { border-color:#D97706; box-shadow:0 0 0 3px rgba(217,119,6,.1); }
        .search-input::placeholder { color:#A8A29E; }
        .carpenter-card { background:#fff; border:1.5px solid #E7E5E4; border-radius:16px; overflow:hidden; animation:fadeUp .35s ease both; transition:box-shadow .2s,border-color .2s; }
        .carpenter-card:hover { box-shadow:0 6px 24px rgba(0,0,0,.06); border-color:#FDE68A; }
        .labour-row { display:flex; align-items:center; gap:12px; padding:11px 20px; border-bottom:1px solid #F5F5F4; transition:background .15s; animation:slideDown .2s ease both; }
        .labour-row:last-child { border-bottom:none; }
        .labour-row:hover { background:#FFFBF7; }
        @media (max-width:768px) {
          .sidebar { position:fixed; left:0; top:0; z-index:50; transform:translateX(-100%); transition:transform .28s ease; height:100%; }
          .sidebar.open { transform:translateX(0); }
          .sidebar-overlay.open { display:block; }
          .topbar { display:flex; align-items:center; gap:12px; padding:14px 16px; background:#fff; border-bottom:1.5px solid #E7E5E4; position:sticky; top:0; z-index:30; }
          .hamburger { display:flex; }
          .main-wrap { flex-direction:column !important; }
          .main-content { padding:16px !important; }
          .summary-row { grid-template-columns:1fr 1fr !important; }
        }
        @media (min-width:769px) and (max-width:1100px) { .sidebar { width:190px; } }
      `}</style>

      <div className="main-wrap" style={{ display:"flex", minHeight:"100vh", fontFamily:"'Plus Jakarta Sans',sans-serif", background:"#FAF7F4" }}>
        <div className={`sidebar-overlay ${sidebarOpen?"open":""}`} onClick={() => setSidebarOpen(false)} />

        {/* SIDEBAR */}
        <aside className={`sidebar ${sidebarOpen?"open":""}`}>
          <div style={{ display:"flex", alignItems:"center", gap:"10px", marginBottom:"28px", padding:"0 4px" }}>
            <div style={{ width:"36px", height:"36px", background:"linear-gradient(135deg,#92400E,#D97706)", borderRadius:"10px", display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0 }}>
              <span style={{ fontSize:"18px" }}>🪚</span>
            </div>
            <div>
              <p style={{ fontWeight:"800", fontSize:"15px", color:"#1C1917" }}>Craftigo</p>
              <p style={{ fontSize:"11px", color:"#A8A29E", fontWeight:"500" }}>Admin Panel</p>
            </div>
          </div>
          <p style={{ fontSize:"11px", fontWeight:"700", color:"#C4B5A4", letterSpacing:"0.7px", textTransform:"uppercase", padding:"0 6px", marginBottom:"6px" }}>Menu</p>
          {navItems.map(n => (
            <button key={n.label} className={`nav-btn ${n.active?"active":""}`}
              onClick={() => { navigate(n.path); setSidebarOpen(false); }}>
              {n.emoji} {n.label}
            </button>
          ))}
          <div style={{ flex:1 }} />
          <div style={{ padding:"12px", background:"#FEF3C7", borderRadius:"12px", border:"1px solid #FDE68A", marginBottom:"10px" }}>
            <p style={{ fontSize:"12px", fontWeight:"700", color:"#92400E" }}>🛡️ Admin Access</p>
            <p style={{ fontSize:"11px", color:"#B45309", marginTop:"2px" }}>Full permissions</p>
          </div>
          <button className="nav-btn danger" onClick={() => { localStorage.clear(); navigate("/login"); }}>🚪 Logout</button>
        </aside>

        <div style={{ flex:1, display:"flex", flexDirection:"column", minWidth:0 }}>
          {/* TOPBAR */}
          <div className="topbar">
            <button className="hamburger" onClick={() => setSidebarOpen(true)}>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                <line x1="3" y1="6" x2="21" y2="6" stroke="#44403C" strokeWidth="2" strokeLinecap="round"/>
                <line x1="3" y1="12" x2="21" y2="12" stroke="#44403C" strokeWidth="2" strokeLinecap="round"/>
                <line x1="3" y1="18" x2="21" y2="18" stroke="#44403C" strokeWidth="2" strokeLinecap="round"/>
              </svg>
            </button>
            <span style={{ fontWeight:"800", fontSize:"16px", color:"#1C1917" }}>🔗 Carpenter & Labour</span>
          </div>

          <main className="main-content" style={{ padding:"28px 28px", flex:1, overflowY:"auto" }}>

            {/* Header */}
            <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", marginBottom:"6px", animation:"fadeUp .3s ease both" }}>
              <div>
                <h1 style={{ fontSize:"24px", fontWeight:"800", color:"#1C1917", letterSpacing:"-0.5px" }}>Carpenter & Labour</h1>
                <p style={{ fontSize:"13px", color:"#A8A29E", marginTop:"3px" }}>
                  {loading ? "Loading…" : `${data.length} carpenters · ${totalLabours} labours total`}
                </p>
              </div>
              <button onClick={fetchData} style={{ padding:"10px 14px", background:"#fff", border:"1.5px solid #E7E5E4", borderRadius:"12px", fontFamily:"'Plus Jakarta Sans',sans-serif", fontSize:"13px", fontWeight:"700", color:"#44403C", cursor:"pointer" }}>
                🔄 Refresh
              </button>
            </div>

            {/* Summary chips */}
            <div className="summary-row" style={{ display:"grid", gridTemplateColumns:"repeat(3,1fr)", gap:"12px", margin:"20px 0", animation:"fadeUp .35s .05s ease both" }}>
              {[
                { emoji:"🪚", label:"Total Carpenters", val:data.length,         bg:"#FEF3C7", bdr:"#FDE68A", tc:"#D97706" },
                { emoji:"🔨", label:"Total Labours",    val:totalLabours,         bg:"#E0F2FE", bdr:"#BAE6FD", tc:"#0369A1" },
                { emoji:"📊", label:"Avg per Carpenter",val:data.length ? Math.round(totalLabours/data.length*10)/10 : 0, bg:"#EDE9FE", bdr:"#DDD6FE", tc:"#7C3AED" },
              ].map(s => (
                <div key={s.label} style={{ background:s.bg, border:`1.5px solid ${s.bdr}`, borderRadius:"14px", padding:"16px 18px", display:"flex", alignItems:"center", gap:"12px" }}>
                  <span style={{ fontSize:"22px" }}>{s.emoji}</span>
                  <div>
                    <p style={{ fontSize:"20px", fontWeight:"800", color:s.tc }}>{s.val}</p>
                    <p style={{ fontSize:"12px", fontWeight:"600", color:"#78716C", marginTop:"1px" }}>{s.label}</p>
                  </div>
                </div>
              ))}
            </div>

            {/* Search */}
            <div style={{ position:"relative", marginBottom:"20px", animation:"fadeUp .35s .08s ease both" }}>
              <span style={{ position:"absolute", left:"14px", top:"50%", transform:"translateY(-50%)", pointerEvents:"none" }}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                  <circle cx="11" cy="11" r="8" stroke="#A8A29E" strokeWidth="2"/>
                  <path d="m21 21-4.35-4.35" stroke="#A8A29E" strokeWidth="2" strokeLinecap="round"/>
                </svg>
              </span>
              <input className="search-input" type="text" placeholder="Search carpenter or labour name…" value={search} onChange={e => setSearch(e.target.value)} />
            </div>

            {/* Cards */}
            {loading ? (
              <div style={{ padding:"60px", textAlign:"center" }}>
                <div style={{ width:"36px", height:"36px", border:"3px solid #FDE68A", borderTop:"3px solid #D97706", borderRadius:"50%", animation:"spin .7s linear infinite", margin:"0 auto 14px" }} />
                <p style={{ color:"#A8A29E", fontSize:"14px" }}>Loading data…</p>
              </div>
            ) : filtered.length === 0 ? (
              <div style={{ padding:"60px", textAlign:"center", background:"#fff", borderRadius:"16px", border:"1.5px solid #E7E5E4" }}>
                <p style={{ fontSize:"40px", marginBottom:"12px" }}>🔍</p>
                <p style={{ color:"#78716C", fontWeight:"700", fontSize:"16px" }}>No results found</p>
                <p style={{ color:"#A8A29E", fontSize:"13px", marginTop:"4px" }}>Try a different search</p>
              </div>
            ) : (
              <div style={{ display:"flex", flexDirection:"column", gap:"14px" }}>
                {filtered.map((c, ci) => {
                  const isOpen = expanded[c.carpenter._id];
                  const hasLabours = c.labours.length > 0;
                  return (
                    <div key={c.carpenter._id} className="carpenter-card" style={{ animationDelay:`${ci*0.05}s` }}>

                      {/* Carpenter header row */}
                      <div
                        onClick={() => toggle(c.carpenter._id)}
                        style={{ display:"flex", alignItems:"center", gap:"14px", padding:"16px 20px", cursor:"pointer", background: isOpen?"#FFFBF5":"#fff", borderBottom: isOpen?"1.5px solid #FDE68A":"none", transition:"background .15s" }}>

                        {/* Avatar */}
                        <div style={{ width:"44px", height:"44px", borderRadius:"12px", background:"linear-gradient(135deg,#FEF3C7,#FDE68A)", border:"1.5px solid #FDE68A", display:"flex", alignItems:"center", justifyContent:"center", fontSize:"18px", fontWeight:"800", color:"#D97706", flexShrink:0 }}>
                          {c.carpenter.name.charAt(0).toUpperCase()}
                        </div>

                        {/* Info */}
                        <div style={{ flex:1, minWidth:0 }}>
                          <div style={{ display:"flex", alignItems:"center", gap:"8px", marginBottom:"2px" }}>
                            <p style={{ fontSize:"15px", fontWeight:"800", color:"#1C1917" }}>{c.carpenter.name}</p>
                            <span style={{ fontSize:"10px", fontWeight:"700", background:"#FEF3C7", border:"1px solid #FDE68A", color:"#D97706", borderRadius:"20px", padding:"2px 8px" }}>🪚 Carpenter</span>
                          </div>
                          <p style={{ fontSize:"12px", color:"#78716C", overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>{c.carpenter.email}</p>
                        </div>

                        {/* Labour count badge */}
                        <div style={{ textAlign:"center", flexShrink:0, marginRight:"8px" }}>
                          <p style={{ fontSize:"20px", fontWeight:"800", color: hasLabours?"#0369A1":"#A8A29E" }}>{c.labours.length}</p>
                          <p style={{ fontSize:"10px", fontWeight:"600", color:"#A8A29E" }}>labours</p>
                        </div>

                        {/* Chevron */}
                        <div style={{ width:"28px", height:"28px", borderRadius:"8px", background: isOpen?"#FEF3C7":"#F5F5F4", border:`1px solid ${isOpen?"#FDE68A":"#E7E5E4"}`, display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0, transition:"all .2s" }}>
                          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" style={{ transform: isOpen?"rotate(180deg)":"rotate(0deg)", transition:"transform .2s" }}>
                            <path d="M6 9l6 6 6-6" stroke={isOpen?"#D97706":"#78716C"} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                          </svg>
                        </div>
                      </div>

                      {/* Labour list */}
                      {isOpen && (
                        <div>
                          {!hasLabours ? (
                            <div style={{ padding:"20px", textAlign:"center", background:"#FAFAF9" }}>
                              <p style={{ fontSize:"22px", marginBottom:"6px" }}>👷</p>
                              <p style={{ fontSize:"13px", color:"#A8A29E", fontWeight:"600" }}>No labours assigned yet</p>
                            </div>
                          ) : (
                            <>
                              {/* Labour table header */}
                              <div style={{ display:"grid", gridTemplateColumns:"2fr 2.5fr 1fr 1fr", padding:"8px 20px", background:"#F9F8F7", borderBottom:"1px solid #F0EDEA" }}>
                                {["Labour Name","Email","Daily Rate","Status"].map(h => (
                                  <span key={h} style={{ fontSize:"10px", fontWeight:"700", color:"#A8A29E", letterSpacing:"0.5px", textTransform:"uppercase" }}>{h}</span>
                                ))}
                              </div>
                              {c.labours.map((l, li) => {
                                const isActive = l.isActive !== false;
                                return (
                                  <div key={l._id} className="labour-row"
                                    style={{ display:"grid", gridTemplateColumns:"2fr 2.5fr 1fr 1fr", animationDelay:`${li*0.04}s` }}>

                                    {/* Name */}
                                    <div style={{ display:"flex", alignItems:"center", gap:"9px" }}>
                                      <div style={{ width:"30px", height:"30px", borderRadius:"50%", background:"#E0F2FE", border:"1.5px solid #BAE6FD", display:"flex", alignItems:"center", justifyContent:"center", fontSize:"12px", fontWeight:"800", color:"#0369A1", flexShrink:0 }}>
                                        {l.name.charAt(0).toUpperCase()}
                                      </div>
                                      <span style={{ fontSize:"13px", fontWeight:"600", color:"#1C1917" }}>{l.name}</span>
                                    </div>

                                    {/* Email */}
                                    <span style={{ fontSize:"12px", color:"#78716C", overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap", alignSelf:"center" }}>{l.email}</span>

                                    {/* Daily rate */}
                                    <span style={{ fontSize:"13px", fontWeight:"700", color:"#059669", alignSelf:"center" }}>
                                      {l.dailyRate ? `Rs.${l.dailyRate}` : <span style={{ color:"#A8A29E", fontWeight:"500" }}>—</span>}
                                    </span>

                                    {/* Status */}
                                    <span style={{ display:"inline-flex", alignItems:"center", gap:"4px", padding:"3px 9px", borderRadius:"20px", fontSize:"10px", fontWeight:"700", width:"fit-content", alignSelf:"center",
                                      background: isActive?"#D1FAE5":"#FEF2F2",
                                      border:     isActive?"1px solid #A7F3D0":"1px solid #FECACA",
                                      color:      isActive?"#059669":"#DC2626" }}>
                                      <span style={{ width:"5px", height:"5px", borderRadius:"50%", background:isActive?"#059669":"#DC2626", display:"inline-block" }} />
                                      {isActive ? "Active" : "Inactive"}
                                    </span>
                                  </div>
                                );
                              })}
                            </>
                          )}
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            )}
          </main>
        </div>
      </div>
    </>
  );
}